{
  "name": "mrewards_onboarding_portal",
  "version": "3.133",
  "private": true,
  "dependencies": {
    "@fortawesome/fontawesome-svg-core": "^7.3.0",
    "@fortawesome/free-brands-svg-icons": "^7.3.1",
    "@fortawesome/free-regular-svg-icons": "^7.3.0",
    "@fortawesome/free-solid-svg-icons": "^7.3.1",
    "@fortawesome/react-fontawesome": "^3.5.0",
    "@jest/core": "^30.2.0",
    "@material-ui/core": "^4.12.3",
    "@material-ui/lab": "^4.0.0-alpha.61",
    "@nivo/bar": "^0.99",
    "@nivo/core": "^0.99",
    "@nivo/line": "^0.99",
    "@react-google-maps/api": "^2.20.3",
    "@rollbar/react": "^1.2.0",
    "dotenv": "^18.0.8",
    "eslint-plugin-react": "^7.37.2",
    "express": "^5.3.0",
    "google-map-react": "^2.2.1",
    "husky": "^9.1.6",
    "lodash": "^4.18.1",
    "material-ui-phone-number": "^2.2.6",
    "moment": "^2.31.0",
    "prettier": "^3.9.10",
    "react": "^18.3.1",
    "react-country-region-selector": "^4.0.6",
    "react-dom": "^18.3.1",
    "react-dropzone": "^20.1.4",
    "react-google-map-image": "^1.0.3",
    "react-intl": "^6.8.7",
    "react-redux": "^9.1.2",
    "react-router-dom": "^7.18.3",
    "redux": "^4.2.1",
    "redux-persist": "^6.0.0",
    "redux-saga": "^1.5.1",
    "rollbar": "^4.1.0",
    "sanitize-html": "^2.18.1",
    "typeface-source-sans-pro": "^1.1.13"
  },
  "engines": {
    "node": "26.x"
  },
  "resolutions": {
    "base-x": ">=3.0.11",
    "d3-color": "^3.1.0",
    "form-data": ">=4.0.6",
    "lodash": "^4.18.1",
    "postcss": "~8.5.10",
    "qs": "^6.14.2",
    "yaml": "^2.8.3"
  },
  "@parcel/resolver-default": {
    "packageExports": true
  },
  "scripts": {
    "start": "parcel src/index.html",
    "prebuild": "rm -rf dist/",
    "build": "node scripts/build.js",
    "test": "chmod u+x ./test.sh & ./test.sh",
    "pretty": "prettier --config .prettierrc --write",
    "precommit": "lint-staged",
    "lint": "eslint --max-warnings 0"
  },
  "husky": {
    "hooks": {
      "pre-commit": "yarn precommit"
    }
  },
  "lint-staged": {
    "{src}/**/*.{js,jsx}": [
      "yarn run pretty",
      "yarn run lint",
      "git add"
    ]
  },
  "eslintConfig": {
    "extends": "react-app"
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  },
  "devDependencies": {
    "@babel/preset-env": "^8.0.7",
    "@babel/preset-react": "^8.0.1",
    "@parcel/packager-raw-url": "2.16.x",
    "@parcel/transformer-webmanifest": "2.16.x",
    "babel-jest": "^30.5.2",
    "buffer": "^5.5.0||^6.0.0",
    "jest": "^30.5.2",
    "jest-environment-jsdom": "^30.5",
    "lint-staged": "^17.6.0",
    "parcel": "2.16.4",
    "path-browserify": "^1.0.1",
    "process": "^0.11.10",
    "react-test-renderer": "^18.3.1",
    "redux-devtools-extension": "^2.13.9"
  },
  "packageManager": "yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"
}
